import { useUiStore } from '@/store/ui';
import { Button, Grid } from '@mui/material';

export type CreateOrCancelButtonsProps = {
  onCancel: () => void;
  cancelTextBtn?: string;
  onSave: () => void;
  saveTextBtn?: string;
  disabled?: boolean;
  pt?: number;
};

const CreateOrCancelButtons: React.FC<CreateOrCancelButtonsProps> = ({
  onCancel,
  cancelTextBtn = 'Cancelar',
  onSave,
  saveTextBtn = 'Guardar',
  disabled = false,
  pt = 6,
}) => {
  const auxiliarBtnCreateEditButtons = useUiStore(
    s => s.auxiliarBtnCreateEditButtons
  );
  const resetAuxBtn = useUiStore(s => s.resetAuxBtn);

  const {
    disabled: disabledAuxBtn,
    onClick: onClickAuxBtn,
    title,
  } = auxiliarBtnCreateEditButtons;

  return (
    <Grid container spacing={1} justifyContent="end" pt={pt}>
      {!disabledAuxBtn && (
        <>
          <Grid item>
            <Button
              sx={{
                marginLeft: '24px',
              }}
              onClick={() => {
                onClickAuxBtn();
                resetAuxBtn();
              }}
              variant="text"
            >
              {title}
            </Button>
          </Grid>
          <span className="spacer"></span>
        </>
      )}

      <Grid item>
        <Button onClick={onCancel} variant="text">
          {cancelTextBtn || 'Cancelar'}
        </Button>
      </Grid>

      <Grid item>
        <Button onClick={onSave} variant="contained" disabled={disabled}>
          {saveTextBtn || 'Guardar'}
        </Button>
      </Grid>
    </Grid>
  );
};

export default CreateOrCancelButtons;
